export const RUN_AB_TEST_ACTION = "RUN_AB_TEST";

export const CHANGE_AB_TEST_VERSION_ACTION = "CHANGE_AB_TEST_VERSION";

export const AB_TEST_STATE = "abTest";

/**
 * Types of PNP offers for AB Testing.
 */

export const PNP_BASE_OFFERS = "pnp-base-offers";

export const PNP_UPGRADED_OFFERS = "pnp-upgraded-offers";

export const STEPPER = "stepper";
/**
 * Types of AB test versions
 */
export const abTestVersions = {
  control: "control",
  strikethrough: "strikethrough",
  "reimagine-postcodes": "reimagine-postcodes",
  [PNP_BASE_OFFERS]: PNP_BASE_OFFERS,
  [PNP_UPGRADED_OFFERS]: PNP_UPGRADED_OFFERS,
  [STEPPER]: STEPPER,
};
